<template>
  <div class="coupon-cover"
       :style="`background-image:url(${images.bg_select_coupon_item});`">
    <div class="amount-row">
      <slot>
        <span class="unit" v-if="beforeUnit">{{ beforeUnit }}</span>
        <span class="amount">{{ price||"-" }}</span>
        <span class="unit" v-if="afterUnit"> {{ afterUnit }}</span>
      </slot>
    </div>
    <div class="description-row">
      <slot name="description">
        {{ description }}
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "couponItemCover",
  props: {
    data: {
      type: Object,
      default: ()=>({}),
    },
    price: {
      type: [String,Number],
      default: "",
    },
    beforeUnit: {
      type: [String,Number],
      default: "￥",
    },
    afterUnit: {
      type: [String,Number],
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  data(){
    const ossPath = this.ossPath;
    return {
      images:{
        bg_select_coupon_item: ossPath + "/pages/home/coupon/bg_select_coupon_item.png",
      },
    }
  },
}
</script>

<style scoped lang="scss">
.coupon-cover{
  width: 81px;
  height: 72px;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  margin-right: 24px;
}
.amount-row{
  font-size: 14px;
  font-weight: bold;
  color: #EB2749;

  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 30px;
  margin-top: 14px;
  /deep/ .amount{
    font-size: 18px;
    & + .unit{
      margin-left: 6px;
    }
  }

}
.description-row{
  width: 90%;
  margin: 7px auto 0;
  font-size: 12px;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// common/selectCoupon/couponItemCover.vue